<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.view_faq") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.questionAr')"
            v-model.trim="data.question_ar"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.questionEn')"
            v-model.trim="data.question_en"
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.answerAr')"
            v-model.trim="data.answer_ar"
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.answerEn')"
            v-model.trim="data.answer_en"
            disabled
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowFaq",

  data() {
    return {
      data: {
        question_ar: null,
        question_en: null,
        answer_ar: null,
        answer_en: null,
      },
    };
  },

  methods: {
    async getData() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `frequentlyAskedQuestions/${this.$route.params.id}`,
        });
        const item = res.data?.data?.FrequentlyAskedQuestion || {};
        this.data.question_ar = item.question_ar;
        this.data.question_en = item.question_en;
        this.data.answer_ar = item.answer_ar;
        this.data.answer_en = item.answer_en;
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to load FAQ details"
        );
      }
    },
  },

  created() {
    this.getData();
  },
};
</script>
